import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';
import { ProgressBarOverlayComponent } from './progress-bar-overlay.component';

@Injectable({ providedIn: 'root' })
export class ProgressBarOverlayService {
  private readonly overlay = inject(Overlay);

  private overlayRef: OverlayRef | undefined;
  private isAttached = false;

  show(): void {
    if (this.isAttached) return;
    this.overlayRef = this.overlay.create({
      positionStrategy: this.overlay.position().global(),
      scrollStrategy: this.overlay.scrollStrategies.block(),
    });
    const componentPortal = new ComponentPortal(ProgressBarOverlayComponent);
    this.overlayRef.attach(componentPortal);
    this.isAttached = true;
  }

  hide(): void {
    if (!this.isAttached) return;
    this.overlayRef?.detach();
    this.overlayRef = undefined;
    this.isAttached = false;
  }
}
